<template>
<p class="right-box-status">
  <span :style="{color:txtColor}">{{title}}</span>
  <span v-if="rightShow">
      <img src="../../../assets/travelAgency/right.png" alt="">
  </span>
</p>
</template>
<script>
    export default {
        components: {},
        props: {
            title: {
                type: String,
                default: ''
            },
            txtColor: {
                type: String,
                default: ''
            },
            rightShow: {
                type: Boolean,
                default: true
            },
            divWidth: {
                type: Number,
                default: 85
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  .right-box-status {
      display: flex;
      align-items: center;
      span {
          color:rgba(102,102,102,1);
          font-size: 12px;
          img{
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top:-3px;

          }
      }
  }
</style>
